// types
import type { ISubModuleConfig } from '~/features/surveys/submodule'

export default function createSurveyRoutes(config: ISubModuleConfig) {
  return [
    {
      name: config.submodulePermissions.PERMISSION,
      path: config.submodulePermissions.ROUTE,
      component: () => import('~/pages/surveys/ui/SurveysPage.vue'),
      meta: { middleware: ['auth'] },
      props: config,
    },
    {
      name: config.submodulePermissions.CREATE.PERMISSION,
      path: config.submodulePermissions.CREATE.ROUTE,
      component: () => import('~/pages/surveys/ui/SurveysFormPage.vue'),
      meta: { middleware: ['auth'] },
      props: config,
    },
    {
      name: config.submodulePermissions.EDIT.PERMISSION,
      path: config.submodulePermissions.EDIT.ROUTE,
      component: () => import('~/pages/surveys/ui/SurveysFormPage.vue'),
      meta: { middleware: ['auth'] },
      props: { isEditing: true, ...config },
    },
    {
      name: config.submodulePermissions.FILL.PERMISSION,
      path: config.submodulePermissions.FILL.ROUTE,
      component: () => import('~/pages/surveys/ui/SurveysFillPage.vue'),
      meta: { middleware: ['auth'] },
      props: { isShared: false, ...config },
    },
    {
      name: config.submodulePermissions.STATISTICS.PERMISSION,
      path: config.submodulePermissions.STATISTICS.ROUTE,
      redirect: { name: config.submodulePermissions.STATISTICS.GENERAL.PERMISSION },
      meta: { middleware: ['auth'] },
      props: config,
    },
    {
      name: config.submodulePermissions.STATISTICS.GENERAL.PERMISSION,
      path: config.submodulePermissions.STATISTICS.GENERAL.ROUTE,
      component: () => import('~/pages/surveys/ui/SurveysStatisticsPage.vue'),
      meta: { middleware: ['auth'] },
      props: config,
    },
    {
      name: config.submodulePermissions.STATISTICS.PRIVATE.PERMISSION,
      path: config.submodulePermissions.STATISTICS.PRIVATE.ROUTE,
      component: () => import('~/pages/surveys/ui/SurveysStatisticsPrivatePage.vue'),
      meta: { middleware: ['auth'] },
      props: config,
    },
    {
      name: config.submodulePermissions.STATISTICS.PRIVATE.USER.PERMISSION,
      path: config.submodulePermissions.STATISTICS.PRIVATE.USER.ROUTE,
      component: () => import('~/pages/surveys/ui/SurveysStatisticsUserPage.vue'),
      meta: { middleware: ['auth'] },
      props: config,
    },
    {
      name: config.submodulePermissions.STATISTICS.PRIVATE.USER.RESPONSE.PERMISSION,
      path: config.submodulePermissions.STATISTICS.PRIVATE.USER.RESPONSE.ROUTE,
      component: () => import('~/pages/surveys/ui/SurveysFormPage.vue'),
      meta: { middleware: ['auth'] },
      props: { withResponse: true, readonly: true, ...config },
    },
  ]
}
